import { OnboardingItemKey } from "../../../common/enums";
import { IOnboardingFlow } from "./onboardingTypes";
import { buildFlow } from "./allSteps";

// Steps for the Employee role.
const employeeStepIds: OnboardingItemKey[] = [
  OnboardingItemKey.GetToKnowPlanny,
  OnboardingItemKey.StudioProfile,
  OnboardingItemKey.StudioWizard,
  OnboardingItemKey.PlanTypes,
  OnboardingItemKey.ServiceTypes,
  OnboardingItemKey.ClassCategories,
  OnboardingItemKey.CreatePlan,
  OnboardingItemKey.PlanWizard,
  OnboardingItemKey.EmployeesList,
  OnboardingItemKey.EmployeeWizard,
  OnboardingItemKey.CreateEvent,
  OnboardingItemKey.EventWizard,
  OnboardingItemKey.EventWizardHybrid,
  OnboardingItemKey.ServiceWizardGuide,
  OnboardingItemKey.BlockedTimeGuide,
  OnboardingItemKey.FirstUser,
  OnboardingItemKey.UserAdd,
  OnboardingItemKey.UserProfile,
  OnboardingItemKey.DashboardKpis,
  OnboardingItemKey.Statistics,
  OnboardingItemKey.StatisticsDetail,
  OnboardingItemKey.Support,
  // Page Guides (hidden, component-driven)
  OnboardingItemKey.RefillCardGuide,
  OnboardingItemKey.RefillCardEmpty,
  OnboardingItemKey.InventoryGuide,
  OnboardingItemKey.InventoryOverviewGuide,
  OnboardingItemKey.InventoryTransfersGuide,
  OnboardingItemKey.CashdeskGuide,
  OnboardingItemKey.CashdeskEmpty,
  OnboardingItemKey.FamiliesGuide,
  OnboardingItemKey.BreakTypesGuide,
  OnboardingItemKey.GymVisitsGuide,
];

export const employeeFlow: IOnboardingFlow = buildFlow(employeeStepIds);
